const darkThemePalette = {
  palette: {
    mode: 'dark',
    background: {
      paper: '#191A19',
      default: '#202120',
      card: '#202120',
    },
    primary: {
      main: '#B9D300',
      light: '#d6e753',
      dark: '#c9df20',
      contrastText: '#FFF',
    },
    divider: '#323332',
    secondary: {
      main: '#7B3BEC',
      light: '#d6e753',
      dark: '#c9df20',
      contrastText: '#FFF',
    },
    text: {
      primary: '#BDBDBC',
      secondary: '#D3D0CC',
      disabled: '#7D807D',
      dark: '#FFFFFF',
    },
  },
  cardBg: {
    main: '#202120',
  },
  brand: {
    main: '#B9D300',
  },
  asideMenu: {
    unselectedIcon: '#BFC5D2',
    selectedIcon: '#B9D300',
    unselectedText: '#797F8D',
    selectedText: '#B9D300',
  },
  clubIcon: {
    light: '#BBB7B7',
    inCall: '#00CF82',
    outCall: '#E52929',
    headerIcon: '#BFC5D2',
    download: '#00CF82',
    upload: '#2E5BFF',
    ping: '#FF2E66',
    join: '#00CF82',
  },
  cardBackGround: {
    lightGray: '#202120',
    lightMain: 'rgba(185, 211, 0, 0.1)',
    darkGray: '#2A2A2A',
  },
  service: {
    pending: '#FFB800',
    active: '#00CF82',
    deactive: '#E52929',
  },
  invoice: {
    main: '#202120',
    payment: '#202120',
    divider: '#323332',
    border: '#7D807D',
  },
  modal: {
    main: '#2A2B2A',
  },
  bonous: {
    border: '#7D807D',
  },
  support: {
    border: '#202120',
  },
};

export default darkThemePalette;
